"use strict";var at=require("./_string-at")(!0);module.exports=function(t,r,e){return r+(e?at(t,r).length:1)};